import router from '../../router';

const state = {
  adminUsers: [],
  adminPlaces: [],
  adminFolders: [],
  adminMirrorFolders: [],
  adminVariables: [],
  loadingAdminUsers: false,
  loadingFolders: false,
  loadingMirrorFolders: false,
  loadingAdminVariables: false,
  adminMirrorCategories: [],
  loadingAdminMirrorCategories: false,
  adminHiddenFields: [],
  loadingAdminHiddenFields: false,
};

const actions = {
  getAdminUsers({ commit, rootState: { user, adminClient } }) {
    const token = user.currentUser.token;
    commit('SET_LOADING_ADMIN_USERS', true);

    adminClient
      .getAdminUsers(token)
      .then(users => {
        commit('SET_ADMIN_USERS', users);
      })
      .catch(error => {
        if (error.response.status === 401) {
          router.push('/login-force');
        }
      })
      .finally(() => {
        commit('SET_LOADING_ADMIN_USERS', false);
      });
  },
  getPlaces({ commit, rootState }) {
    const token = rootState.user.currentUser.token;

    rootState.adminClient
      .getPlaces(token)
      .then(places => {
        commit('SET_PLACES', places);
      })
      .catch(error => {
        if (error.response.status === 401) {
          router.push('/login-force');
        }
      });
  },
  getFolders({ commit, rootState }) {
    const token = rootState.user.currentUser.token;
    commit('SET_LOADING_FOLDERS', true);

    rootState.adminClient
      .getFolders(token)
      .then(folders => {
        commit('SET_FOLDERS', folders);
      })
      .catch(error => {
        if (error.response.status === 401) {
          router.push('/login-force');
        }
      })
      .finally(() => {
        commit('SET_LOADING_FOLDERS', false);
      });
  },
  createFolder({ commit, dispatch, rootState }, folder) {
    const token = rootState.user.currentUser.token;
    commit('SET_LOADING_FOLDERS', true);

    rootState.adminClient
      .createFolder(token, folder)
      .then(() => {
        dispatch(
          'snackbar/showSnackbarWithMessage',
          {
            message: 'Gaveta cadastrada com sucesso!',
            type: 'success',
          },
          { root: true },
        );
      })
      .catch(error => {
        if (error.response.status === 401) {
          router.push('/login-force');
        } else {
          dispatch(
            'snackbar/showSnackbarWithMessage',
            {
              message: 'Erro ao cadastrar gaveta.',
              type: 'error',
            },
            { root: true },
          );
        }
      })
      .finally(() => {
        commit('SET_LOADING_FOLDERS', false);
        dispatch('getFolders');
      });
  },
  updateFolder({ commit, dispatch, rootState }, folderList) {
    const token = rootState.user.currentUser.token;
    commit('SET_LOADING_FOLDERS', true);

    rootState.adminClient
      .updateFolders(token, folderList)
      .then(() => {
        dispatch(
          'snackbar/showSnackbarWithMessage',
          {
            message: 'Gavetas atualizadas com sucesso!',
            type: 'success',
          },
          { root: true },
        );
      })
      .catch(error => {
        if (error.response.status === 401) {
          router.push('/login-force');
        } else {
          dispatch(
            'snackbar/showSnackbarWithMessage',
            {
              message: 'Erro ao atualizar as gavetas.',
              type: 'error',
            },
            { root: true },
          );
        }
      })
      .finally(() => {
        dispatch('getFolders');
        commit('SET_LOADING_FOLDERS', false);
      });
  },
  getMirrorCategories({ commit, rootState }) {
    const token = rootState.user.currentUser.token;
    commit('SET_LOADING_ADMIN_MIRROR_CATEGORIES', true);

    rootState.adminClient
      .getMirrorCategories(token)
      .then(category => {
        commit('SET_ADMIN_MIRROR_CATEGORIES', category);
      })
      .catch(error => {
        if (error.response.status === 401) {
          router.push('/login-force');
        }
      })
      .finally(() => {
        commit('SET_LOADING_ADMIN_MIRROR_CATEGORIES', false);
      });
  },
  createMirrorCategory({ commit, rootState, dispatch }, category) {
    const token = rootState.user.currentUser.token;
    commit('SET_LOADING_ADMIN_MIRROR_CATEGORIES', true);

    rootState.adminClient
      .createMirrorCategory(token, category)
      .then(async () => {
        dispatch(
          'snackbar/showSnackbarWithMessage',
          {
            message: 'Categoria de espelho cadastrado com sucesso!',
            type: 'success',
          },
          { root: true },
        );
        await dispatch('getMirrorCategories');
      })
      .catch(error => {
        if (error.response.status === 401) {
          router.push('/login-force');
        }
      })
      .finally(() => {
        commit('SET_LOADING_ADMIN_MIRROR_CATEGORIES', false);
      });
  },
  updateMirrorCategory({ commit, rootState, dispatch }, category) {
    const token = rootState.user.currentUser.token;
    commit('SET_LOADING_ADMIN_MIRROR_CATEGORIES', true);

    rootState.adminClient
      .updateMirrorCategory(token, category)
      .then(async () => {
        dispatch(
          'snackbar/showSnackbarWithMessage',
          {
            message: 'Categoria de espelho editada com sucesso!',
            type: 'success',
          },
          { root: true },
        );
        await dispatch('getMirrorCategories');
      })
      .catch(error => {
        if (error.response.status === 401) {
          router.push('/login-force');
        } else {
          dispatch(
            'snackbar/showSnackbarWithMessage',
            {
              message: 'Erro ao atualizar categoria de espelho.',
              type: 'error',
            },
            { root: true },
          );
        }
      })
      .finally(() => {
        commit('SET_LOADING_ADMIN_MIRROR_CATEGORIES', false);
      });
  },
  deleteMirrorCategory({ rootState, commit, dispatch }, idCategory) {
    const token = rootState.user.currentUser.token;
    commit('SET_LOADING_ADMIN_MIRROR_CATEGORIES', true);

    rootState.adminClient
      .deleteMirrorCategory(token, idCategory)
      .then(async () => {
        dispatch(
          'snackbar/showSnackbarWithMessage',
          {
            message: 'Categoria de espelho deletada com sucesso!',
            type: 'success',
          },
          { root: true },
        );
        await dispatch('getMirrorCategories');
      })
      .catch(error => {
        if (error.response.status === 401) {
          router.push('/login-force');
        } else if (
          error.response.status === 400 &&
          error.response.data.detail === 'mirror-associate-in-category'
        ) {
          dispatch(
            'snackbar/showSnackbarWithMessage',
            {
              message:
                'Não é possivel remover uma categoria que possui espelho associado.',
              type: 'error',
            },
            { root: true },
          );
        } else {
          dispatch(
            'snackbar/showSnackbarWithMessage',
            {
              message: 'Erro ao deletar categoria de espelho.',
              type: 'error',
            },
            { root: true },
          );
        }
      })
      .finally(() => {
        commit('SET_LOADING_ADMIN_MIRROR_CATEGORIES', false);
      });
  },
  getMirrorFolders({ commit, rootState }) {
    const token = rootState.user.currentUser.token;
    commit('SET_LOADING_MIRROR_FOLDERS', true);

    rootState.adminClient
      .getMirrorFolders(token)
      .then(folders => {
        commit('SET_MIRROR_FOLDERS', folders);
      })
      .catch(error => {
        if (error.response.status === 401) {
          router.push('/login-force');
        }
      })
      .finally(() => {
        commit('SET_LOADING_MIRROR_FOLDERS', false);
      });
  },
  createMirrorFolder({ commit, dispatch, rootState }, mirror) {
    const token = rootState.user.currentUser.token;
    commit('SET_LOADING_MIRROR_FOLDERS', true);

    rootState.adminClient
      .createMirrorFolder(token, mirror)
      .then(() => {
        dispatch(
          'snackbar/showSnackbarWithMessage',
          {
            message: 'Espelho cadastrado com sucesso!',
            type: 'success',
          },
          { root: true },
        );
      })
      .catch(error => {
        if (error.response.status === 401) {
          router.push('/login-force');
        } else {
          dispatch(
            'snackbar/showSnackbarWithMessage',
            {
              message: 'Erro ao cadastrar espelho.',
              type: 'error',
            },
            { root: true },
          );
        }
      })
      .finally(() => {
        commit('SET_LOADING_MIRROR_FOLDERS', false);
        dispatch('getMirrorFolders');
      });
  },
  updateMirrorFolder({ commit, dispatch, rootState }, mirror) {
    const token = rootState.user.currentUser.token;
    commit('SET_LOADING_MIRROR_FOLDERS', true);

    rootState.adminClient
      .updateMirrorFolder(token, mirror)
      .then(() => {
        dispatch(
          'snackbar/showSnackbarWithMessage',
          {
            message: 'Espelho atualizado com sucesso!',
            type: 'success',
          },
          { root: true },
        );
      })
      .catch(error => {
        if (error.response.status === 401) {
          router.push('/login-force');
        } else {
          dispatch(
            'snackbar/showSnackbarWithMessage',
            {
              message: 'Erro ao cadastrar espelho.',
              type: 'error',
            },
            { root: true },
          );
        }
      })
      .finally(() => {
        commit('SET_LOADING_MIRROR_FOLDERS', false);
        dispatch('getMirrorFolders');
      });
  },
  grantAdminRole(
    { commit, dispatch, rootState: { user, adminClient } },
    username,
  ) {
    const token = user.currentUser.token;
    commit('SET_LOADING_ADMIN_USERS', true);

    adminClient
      .grantAdminRole(token, { name: username })
      .then(() => {
        dispatch('getAdminUsers');
        dispatch(
          'snackbar/showSnackbarWithMessage',
          {
            message: 'Usuário cadastrado com sucesso!',
            type: 'success',
          },
          { root: true },
        );
      })
      .catch(error => {
        if (error.response.status === 401) {
          router.push('/login-force');
        }
      })
      .finally(() => {
        commit('SET_LOADING_ADMIN_USERS', false);
      });
  },

  removeAdminRole(
    { commit, dispatch, rootState: { user, adminClient } },
    { id },
  ) {
    const token = user.currentUser.token;
    commit('SET_LOADING_ADMIN_USERS', true);

    adminClient
      .removeAdminRole(token, id)
      .then(() => {
        dispatch('getAdminUsers');
      })
      .catch(error => {
        if (error.response.status === 401) {
          router.push('/login-force');
        }
      })
      .finally(() => {
        commit('SET_LOADING_ADMIN_USERS', false);
      });
  },

  removeMirror({ dispatch, rootState }, mirror) {
    const token = rootState.user.currentUser.token;
    rootState.adminClient
      .removeMirror(token, mirror)
      .then(() => {
        dispatch(
          'snackbar/showSnackbarWithMessage',
          {
            message: 'Espelho deletado com sucesso!',
            type: 'success',
          },
          { root: true },
        );
      })
      .catch(error => {
        if (error.response.status === 401) {
          router.push('/login-force');
        } else {
          dispatch(
            'snackbar/showSnackbarWithMessage',
            {
              message: 'Erro ao deletar espelho.',
              type: 'error',
            },
            { root: true },
          );
        }
      })
      .finally(() => {
        dispatch('getMirrorFolders');
      });
  },

  getHiddenFields({ commit, rootState }) {
    const token = rootState.user.currentUser.token;
    commit('SET_LOADING_ADMIN_HIDDEN_FIELDS', true);

    rootState.adminClient
      .getHiddenFields(token)
      .then(hiddenFields => {
        commit('SET_ADMIN_HIDDEN_FIELDS', hiddenFields);
      })
      .catch(error => {
        if (error.response.status === 401) {
          router.push('/login-force');
        }
      })
      .finally(() => {
        commit('SET_LOADING_ADMIN_HIDDEN_FIELDS', false);
      });
  },
  createHiddenField({ commit, rootState, dispatch }, hiddenField) {
    const token = rootState.user.currentUser.token;
    commit('SET_LOADING_ADMIN_HIDDEN_FIELDS', true);

    rootState.adminClient
      .createHiddenField(token, hiddenField)
      .then(async () => {
        dispatch(
          'snackbar/showSnackbarWithMessage',
          {
            message: 'Campo cadastrado com sucesso!',
            type: 'success',
          },
          { root: true },
        );
        await dispatch('getHiddenFields');
      })
      .catch(error => {
        if (error.response.status === 401) {
          router.push('/login-force');
        } else {
          dispatch(
            'snackbar/showSnackbarWithMessage',
            {
              message: 'Erro ao cadastrar campo.',
              type: 'error',
            },
            { root: true },
          );
        }
      })
      .finally(() => {
        commit('SET_LOADING_ADMIN_HIDDEN_FIELDS', false);
      });
  },

  deleteHiddenField({ rootState, commit, dispatch }, idHiddenField) {
    const token = rootState.user.currentUser.token;
    commit('SET_LOADING_ADMIN_HIDDEN_FIELDS', true);

    rootState.adminClient
      .deleteHiddenField(token, idHiddenField)
      .then(async () => {
        dispatch(
          'snackbar/showSnackbarWithMessage',
          {
            message: 'Campo deletado com sucesso!',
            type: 'success',
          },
          { root: true },
        );
        await dispatch('getHiddenFields');
      })
      .catch(error => {
        if (error.response.status === 401) {
          router.push('/login-force');
        } else {
          dispatch(
            'snackbar/showSnackbarWithMessage',
            {
              message: 'Erro ao deletar campo.',
              type: 'error',
            },
            { root: true },
          );
        }
      })
      .finally(() => {
        commit('SET_LOADING_ADMIN_HIDDEN_FIELDS', false);
      });
  },
  getAdminVariables({ commit, rootState }) {
    const token = rootState.user.currentUser.token;
    commit('SET_LOADING_ADMIN_VARIABLES', true);

    rootState.adminClient
      .getVariables(token)
      .then(variables => {
        commit('SET_ADMIN_VARIABLES', variables);
      })
      .catch(error => {
        if (error.response.state === 401) {
          router.push('/login-force');
        }
      })
      .finally(() => {
        commit('SET_LOADING_ADMIN_VARIABLES', false);
      });
  },

  updateAdminVariables({ commit, dispatch, rootState }, variablesList) {
    const token = rootState.user.currentUser.token;
    commit('SET_LOADING_ADMIN_VARIABLES', true);

    rootState.adminClient
      .updateVariables(token, variablesList)
      .then(() => {
        dispatch(
          'snackbar/showSnackbarWithMessage',
          {
            message: 'Variáveis atualizadas com sucesso!',
            type: 'success',
          },
          { root: true },
        );
      })
      .catch(error => {
        if (error.response.status === 401) {
          router.push('/login-force');
        } else {
          dispatch(
            'snackbar/showSnackbarWithMessage',
            {
              message: 'Erro ao salvar as variáveis.',
              type: 'error',
            },
            { root: true },
          );
        }
      })
      .finally(() => {
        dispatch('getAdminVariables');
        commit('SET_LOADING_ADMIN_VARIABLES', false);
      });
  },
};

const mutations = {
  SET_ADMIN_USERS(state, items) {
    state.adminUsers = items;
  },
  SET_PLACES(state, items) {
    state.adminPlaces = items;
  },
  SET_FOLDERS(state, items) {
    state.adminFolders = items;
  },
  SET_MIRROR_FOLDERS(state, value) {
    state.adminMirrorFolders = value;
  },
  SET_ADMIN_VARIABLES(state, value) {
    state.adminVariables = value;
  },
  SET_LOADING_ADMIN_USERS(state, value) {
    state.loadingAdminUsers = value;
  },
  SET_LOADING_FOLDERS(state, value) {
    state.loadingFolders = value;
  },
  SET_LOADING_MIRROR_FOLDERS(state, value) {
    state.loadingMirrorFolders = value;
  },
  SET_LOADING_ADMIN_VARIABLES(state, value) {
    state.loadingAdminVariables = value;
  },
  SET_ADMIN_MIRROR_CATEGORIES(state, value) {
    state.adminMirrorCategories = value;
  },
  SET_LOADING_ADMIN_MIRROR_CATEGORIES(state, value) {
    state.loadingAdminMirrorCategories = value;
  },
  SET_ADMIN_HIDDEN_FIELDS(state, value) {
    state.adminHiddenFields = value;
  },
  SET_LOADING_ADMIN_HIDDEN_FIELDS(state, value) {
    state.loadingAdminHiddenFields = value;
  },
};

export default {
  state,
  actions,
  mutations,
  namespaced: true,
};
